import { Component, Prop, PropSync, ProvideReactive } from "vue-property-decorator";
import Dictionary from "@/types/Dictionary";
import Mask from "@/types/Config/Mask";
import { ThemeUtils } from "@/components/commons/Utils";

/** Template à utiliser sur tous les panneaux de fonction de composant Config */
@Component
export default class FeatureConfig extends ThemeUtils {
	/** Variant de couleur à appliquer sur le composant */
	@Prop({ default: () => "Primary" })
	@ProvideReactive()
	public Variant!: string;

	/** Liste complète des configurations de la featureConfig : datablocks + autres données hors DataBlocks */
	@PropSync('Configs', { default: () => {} })  /** , type: String[]  */
	public configs!: Dictionary<any>;

    /** Masque de configuration sélectionné */
    @Prop()
    public SelectedMask!: Mask;

    @PropSync('ShowOverlay', {default: () => false })
    public showOverlay!: boolean;

    /** Liste des erreurs liées à la configuration de la fonction */
    @PropSync('Errors', { default: () => [] })
    public errorList!: { Message: string }[];

    /** Chargement des listes en commun pour les fonctions utilisant les Features */
    async created() {
        let perimeterList: string = "Expendable,UsageType,Purpose,SynthesisType,Provider,Tariff,Contract,Owner,SubscriptionHolder,ObjectType,PayingInvoice,InvoiceFlow,BudgetFlow,StatementFlow,DistributorFlow,StartDate";

        /** Chargement des énumérations: Liste Répartition, Type de Synthése */
        await this.$store.dispatch("LoadListEnums", { featureName: this.configs["Feature"] ?? undefined, enumNames: ['FlowType', 'FinancialFlow', 'SynthesisDistribution', 'SynthesisType', 'IssuerType'] });

        /** Chargement des listes: Fournisseur, Contrat, Tarif, Type d'objet, Modéle Budgétaire, Type de Coût, Vocation, Usage, Energie */
        await this.$store.dispatch("LoadListItems", [{ listName: 'Provider' }, { listName: 'Contract' }, { listName: 'Tariff' }, { listName: 'ObjectType' }, { listName: 'BudgetModel' }, { listName: 'CostType' }, { listName: 'Purpose' }, { listName: 'UsageType' }, { listName: 'Expendable' }]);

        /** Chargement de la liste d'item selon le périmètre de l'utilisateur 
         * ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ Attention conserver cet appel en dernier pour ne pas bloquer les chargement de listes */
        await this.$store.dispatch("LoadPerimeterItems", { listName: perimeterList });
    }
}